import { gql } from '@apollo/client';

export const GENERATE_BIO_TAGS = gql`
  query GenerateBioTags($bioText: String!, $userContext: BioContextInput) {
    generateBioTags(bioText: $bioText, userContext: $userContext)
  }
`;